import styles from "./DirectionSchema.module.scss"
import { MapDirection } from "../../components/Map/Map";
import { about_direction } from "@/resources/locale";
import addressIcon from "@/assets/icons/addressMark.svg";
import metroIcon from "@/assets/icons/metro.svg";
import busIcon from "@/assets/icons/bus.svg";

export const DirectionSchema = () => {
	return (
		<div className={styles.main}>
			<div className={styles.wrapper}>
				<div className={styles.textContent}>
					<p className={styles.subTitle}>
						Схема проезда
					</p>
					<div className={styles.itemContainer}>
						<div className={styles.itemTitle}>
							<img src={addressIcon} alt="address icon" />
							<span>Адрес:</span>
						</div>
						<div className={styles.itemText}>
							<a target="_blank" href={'https://yandex.ru/maps/213/moscow/house/malaya_letovskaya_ulitsa_8/Z04YcgZgSUwAQFtvfXl2cX1gZQ==/?ll=37.410097%2C55.570131&z=17.1'} rel="noreferrer">
								{about_direction.titles.ADDRESS}
							</a>
						</div>
					</div>
					<div className={styles.itemContainer}>
						<div className={styles.itemTitle}>
							<img src={metroIcon} alt="address icon" />
							<span>Ближайшее метро</span>
						</div>
						<div className={styles.itemText}>
							{about_direction.titles.METRO}
						</div>
					</div>
					<div className={styles.itemContainer}>
						<div className={styles.itemTitle}>
							<img src={busIcon} alt="address icon" />
							<span>Автобус от станции метро</span>
						</div>
						<div className={styles.itemText}>
							{about_direction.titles.BUS}
						</div>
					</div>
				</div>
			   <div className={styles.map}>
					<MapDirection/>
			   </div>
			</div>
		</div>
	)
}